
import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class QuestionTag extends Vue {
  @Prop({
    type: Number,
    required: true
    // default: 1
  })
  questionType!: number;

  colorClass(): string[] {
    switch (this.questionType) {
      case 1:
        return ["单选题", "q-1"];
      case 2:
        return ["多选题", "q-2"];
      case 5:
        return ["填空题", "q-5"];
      case 6:
        return ["视频问答题", "q-6"];
      case 7:
        return ["测评单选题", "q-7"];
      case 8:
        return ["音频题", "q-8"];
      case 101:
        return ["通勤时间题", "q-101"];
      case 102:
        return ["色盲检测", "q-102"];
      default:
        return ["其他类型", "q-other"];
    }
  }
}
